import * as TYPES from '../types';
const initialState = [
  {
    name:'-',
    displayName: '-',
    num: 1
  },
  {
    name:'-',
    displayName: '-',
    num: 2
  },
  {
    name:'-',
    displayName: '-',
    num: 3
  }
];

export const customEvents = (state = initialState, action) => { // to review
    const newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
      case TYPES.GET_CUSTOM_EVENTS:
        if(!newState.customEvents){
            newState.customEvents = {};
          }
        newState.customEvents[action.teamId] = action.customEvents;
        return newState;
      default:
        return state;
    }
  };

export const customAlerts = (state = {} , action) => {
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case TYPES.GET_TABLE_ALERTS:
      if(!newState.customAlerts){
          newState.customAlerts = {};
        }
      newState.customAlerts[action.teamId] = action.customAlerts;
      return newState;
    case TYPES.SAVE_HITED_ALERTS:
      if(!newState.hitedAlerts){
        newState.hitedAlerts = {};
      }
      newState.hitedAlerts[action.gameId] = action.alert;
      return newState;
    default:
      return state;
  }
};

export const customSpeedAlerts = (state = {} , action) => {
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case TYPES.SET_SPEED_ALERTS:
      
      if(!newState.customSpeedAlerts){
        newState.customSpeedAlerts = {};
      }
      newState.customSpeedAlerts = action.speedAlerts;
      return newState;
    default:
      return state;
  }
};
